/**
 * Check for correct domain name (dev/test suffix) and port.
 *
 * For example for gateway:
 *    - on dev environment - gwdev.alaricsecurities.net:54072
 *    - on test environment - gwtest.alaricsecurities.net:54073
 */

const USE_GATEWAY_RELAY = true;
const USE_REPORTING_API_DIRECTLY = false;
const GATEWAY_ROOT = 'apigw-bff-dev.alaricsecurities.net/capital';

const mainConfig = {
  portalId: 1470, // DemoAceCapitalPortal
  portalLang: 'bg',
  auth: {
    issuer: 'https://auth-dev.alaricsecurities.net',
    clientId: 'DemoAceCapitalPortal',
    loginRedirectUrl: 'https://pari-dev.capital.bg/auth-result',
    redirectUrlConfirmEmail: 'https://pari-dev.capital.bg/email-confirm',
    redirectUrlEmailConfirmed: 'https://pari-dev.capital.bg/email-confirmed',
    redirectUrlResetEmail: 'https://pari-dev.capital.bg/email-reset',
    redirectUrlResendEmail: 'https://pari-dev.capital.bg/email-resend',
    redirectUrlPhoneVerified: 'https://pari-dev.capital.bg/phone-verify',
    postLogoutRedirectUrl: 'https://pari-dev.capital.bg/authentication/login',
    bffLoginUrl: `https://${GATEWAY_ROOT}/bff/login`,
    bffUserUrl: `https://${GATEWAY_ROOT}/bff/user`,
    bffLogoutUrl: `https://${GATEWAY_ROOT}/bff/logout`,
    bffRedeemSignupUrl: `https://${GATEWAY_ROOT}/bff/onboarding/redeem-signup`,
    redirectUrlFunds: 'https://pari-dev.capital.bg/funds',
    redirectUrlProfileSecurity: 'https://pari-dev.capital.bg/overview',
    // 1 - Alaric, 2 - Flb
    tenantId: 2002,
    scopes: [
      'roles',
      'TokenserverAPI.write',
      'TokenserverAPI.read',
      'tenant',
      'Alaric.FileStorage',
      'offline_access',
      'Alaric.Payment',
      'Alaric.Gateway',
      'Alaric.CRM',
      'IdentityServerApi',
      'phone',
      'two_factor_enabled',
      'Alaric.Audit',
      'Alaric.Subscription',
      'Alaric.Entitlement',
      'Alaric.Reporting',
      'platform',
      'Alaric.MarketData',
      'user_relation',
      'Alaric.News',
      'Alaric.Tapi',
      'Alaric.Fundamental',
      'openid',
      'profile',
      'email',
      'Alaric.MS',
      'Alaric.Administrative',
      'openid',
    ],
  },
  crm: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/customer` : 'https://crm-api-dev.alaricsecurities.net',
  },
  pwp: {
    url: 'https://alaric-pro-dev.alaricsecurities.net/',
  },
  fundamental: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/fundamental` : 'https://fundamental-dev.alaricsecurities.net/api',
  },
  reporting: {
    url: (
      USE_REPORTING_API_DIRECTLY
        ? 'https://rpt-dev.alaricsecurities.net/api'
        : `https://${GATEWAY_ROOT}/reporting`
    ),
  },
  reportingFile: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/reporting` : 'https://rpt-dev.alaricsecurities.net/api',
  },
  news: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/news/v1` : 'https://news-dev.alaricsecurities.net/api/v1',
  },
  file: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/file/v1` : 'https://file-dev.alaricsecurities.net/api/v1',
  },
  gateway: {
    url: GATEWAY_ROOT,
  },
  marketData: {
    url: 'ws://38.132.123.43:8000',
  },
  trading: {
    url: `wss://${GATEWAY_ROOT}/trading`,
  },
  payment: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/payment/v1` : 'https://pay-dev.alaricsecurities.net/api/v1/Payment',
  },
  ams: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/message` : 'https://ams-dev.alaricsecurities.net/api',
  },
  cdn: {
    url: USE_GATEWAY_RELAY ? `https://${GATEWAY_ROOT}/content` : 'https://cdn-dev.alaricsecurities.net',
  },
  capital_rss: {
    url: 'https://www.capital.bg/rss/investment-game/?limit=12',
  },
  currentEnv: 'dev',
  dateFormat: 'LL',
  links: {
    abonamentUrl: 'https://www.capital.bg/abonament/',
    fundPortalUrl: 'https://myportal-dev.alaric.bg/',
    privacyPolicyUrl: 'https://alaricsecurities.com/privacy-policy/',
    privacyPolicyCapitalUrl: 'https://www.economedia.bg/privacy',
    tournamentRulesCapitalUrl: 'https://www.capital.bg/pari/pravila/',
    cookiesPolicyUrl: 'https://alaricsecurities.com/cookie-policy/',
    helpCenterUrl: 'https://alaricsecurities.com/contact/#',
    signUpUrl: 'https://alaric-pro-dev.alaricsecurities.net/authentication/sign-up/individual?portalId=DemoAceCapitalPortal',
    etfInfo: 'https://alaricsecurities.com/services/etf-trading/',
    alaricUrl: 'https://alaricsecurities.com/platforms/hammer-lite-web-mobile/',
  },
};

/** Needed for tests */
export function changeEnv(env: any) { mainConfig.currentEnv = env; }

export default mainConfig;
